import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowRightOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.19 7.31a1 1 0 0 0 0 1.48L23.5 15H6a1 1 0 0 0 0 2h17.5l-6.31 6.21a1 1 0 0 0 0 1.48 1.07 1.07 0 0 0 1.5 0l8-7.89A1.1 1.1 0 0 0 27 16a1.13 1.13 0 0 0-.31-.8l-8-7.89a1.07 1.07 0 0 0-1.5 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowRightOutlineSVG);
ForwardRef.displayName = "IconArrowRightOutline";
export { ForwardRef as IconArrowRightOutline };
